import React from "react"
import Icon from "icons"
import { RatingContainer, RatingStars } from "./styles"

const RatingByLine = ({ rating, reviewCount, hideCount, ...props }) => {
  const halfRoundedRating = Math.floor(rating * 2) / 2
  const wholeStars = Math.floor(rating)
  const halfStar = halfRoundedRating % 1 !== 0
  const emptyStars = Math.floor(5 - halfRoundedRating)

  return (
    <RatingContainer {...props}>
      <RatingStars>
        {Array(wholeStars)
          .fill(0)
          .map((i, idx) => (
            <Icon id="star-rating-full-icon" key={`star-full-${idx}`} />
          ))}
        {halfStar && <Icon id="star-rating-half-icon" />}
        {Array(emptyStars)
          .fill(0)
          .map((i, idx) => (
            <Icon id="star-rating-empty-icon" key={`star-empty-${idx}`} />
          ))}
      </RatingStars>
      {!hideCount && <strong>({reviewCount || rating})</strong>}
    </RatingContainer>
  )
}

export default RatingByLine
